






import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class OrderedListSmallFont extends Vue {}
